module.exports = __webpack_public_path__ + "img/reupload.ee6e92ee.svg";